/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject";
import QwoachDataManager from "@/core/js/backend/QwoachDataManager";
import TimeBasedItem from "@shared/DueDatedItem/TimeBasedItem";
import {TimeBasedItemType} from "@shared/DueDatedItem/TimeBasedItemEnums";
import {classToClass} from "@qwoach/class-transformer-wrapper";

export default class TimeBasedItemManager extends DbBaseObject{

	dataManager: QwoachDataManager

	timeBasedItemListCache = {}

	constructor(dataManager: QwoachDataManager) {
		super();
		this.dataManager = dataManager
	}

	async loadTimeBasedItem(timeBasedItemId){
		let timeBasedItem
		if(timeBasedItemId){
			timeBasedItem = this.timeBasedItemListCache[timeBasedItemId]
			if(!timeBasedItem){
				timeBasedItem = await this.dataManager.getTimeBasedItem(timeBasedItemId)
				this.timeBasedItemListCache[timeBasedItemId] = timeBasedItem
			}
		}
		return timeBasedItem
	}

	async syncTimeBasedItem(parentItem, itemType: TimeBasedItemType, timeBasedItemProvider = timeBasedItem => timeBasedItem){
		let needSaveParentItem = false

		let dueDateTs = parentItem.dueDateTs
		let timeBasedItemId = parentItem.timeBasedItemId

		if(!dueDateTs && !timeBasedItemId){
			console.log("syncTimeBasedItem: no actions")
			return false
		}
		let timeBasedItem = await this.loadTimeBasedItem(timeBasedItemId)

		console.log(`syncTimeBasedItem: dueDateTs = ${dueDateTs}, timeBasedItemId = ${timeBasedItemId}, timeBasedItem = ${timeBasedItem}`)

		if(dueDateTs > 0 && (!timeBasedItemId || !timeBasedItem)){
			console.log("syncTimeBasedItem: create")
			needSaveParentItem = await this.createTimeBasedItem(parentItem, timeBasedItem, itemType, timeBasedItemProvider)
		} else if(!dueDateTs && timeBasedItemId){
			console.log("syncTimeBasedItem: delete")
			needSaveParentItem = await this.deleteTimeBasedItem(parentItem, timeBasedItem)
		} else if(timeBasedItem){
			console.log("syncTimeBasedItem: update")
			needSaveParentItem = await this.updateTimeBasedItem(parentItem, timeBasedItem, itemType, timeBasedItemProvider)
		} else {
			console.log("syncTimeBasedItem: no actions 2")

		}
		return needSaveParentItem
	}

	defaultTimeBasedItemProvider(parentItem, timeBasedItem = new TimeBasedItem(), itemType: TimeBasedItemType, timeBasedItemProvider){
		let timeBasedItemNew = classToClass(timeBasedItem)
		timeBasedItemNew.title = 			 parentItem.title || parentItem.name || timeBasedItem.title
		timeBasedItemNew.parentType = 		 itemType 		|| timeBasedItem.parentType
		timeBasedItemNew.parentId = 		 parentItem.id 	|| timeBasedItem.parentId
		timeBasedItemNew.parentSecondaryId = parentItem.parentId || timeBasedItem.parentSecondaryId

		timeBasedItemNew.dueDateTs = 		 parentItem.dueDateTs || timeBasedItem.dueDateTs
		timeBasedItemNew.isCompleted = 		 parentItem.isCompleted || false
		timeBasedItemNew.dateCompletedTs = 	 parentItem.dateCompletedTs || timeBasedItem.dateCompletedTs

		timeBasedItemNew = timeBasedItemProvider(timeBasedItemNew) || timeBasedItemNew

		return timeBasedItemNew
	}

	async createTimeBasedItem(parentItem, timeBasedItem, itemType, timeBasedItemProvider){
		let timeBasedItemFinal = this.defaultTimeBasedItemProvider(parentItem, timeBasedItem, itemType, timeBasedItemProvider)
		timeBasedItemFinal = await this.dataManager.createTimeBasedItem(timeBasedItemFinal)
		parentItem.timeBasedItemId = timeBasedItemFinal.id
		return true
	}


	async deleteTimeBasedItem(parentItem, timeBasedItem){
		parentItem.timeBasedItemId = null
		await this.dataManager.deleteTimeBasedItem(timeBasedItem)
		return true
	}

	async updateTimeBasedItem(parentItem, timeBasedItem, itemType, timeBasedItemProvider){
		let updatedTimeBasedItem = this.defaultTimeBasedItemProvider(parentItem, timeBasedItem, itemType, timeBasedItemProvider)
		let hasChanged = !this.isEqualTimeBasedItems(updatedTimeBasedItem, timeBasedItem)
		updatedTimeBasedItem.id = timeBasedItem.id
		updatedTimeBasedItem.createdAt = timeBasedItem.createdAt
		console.log("syncTimeBasedItem: update hasChanged = ", hasChanged)
		if(hasChanged){
			await this.dataManager.updateTimeBasedItem(updatedTimeBasedItem)
		}
		return hasChanged
	}

	isEqualTimeBasedItems(l, r){
		let isEqual =
			   l.dueDateTs == r.dueDateTs
			&& l.isCompleted == r.isCompleted
			&& l.dateCompletedTs == r.dateCompletedTs
			&& l.title == r.title
		return isEqual
	}


}



